import Error from '../shared/error';
import { APIErrorType } from '../../api';
import Loader from '../shared/loader';
import Segment from '../shared/segment';
import { useExamReportsRanking } from '../../hooks/react-query/use-exam-report';
import { useParams } from 'react-router-dom';
import ExamRankingTable from './table';
import { useStudent } from '../../hooks/react-query/use-student';
import { useExam } from '../../hooks/react-query/use-exam';
import ExamRankingTitle from './title';

function ExamRankingContainer() {
  const { examId } = useParams();
  const { data: student } = useStudent();
  const {
    isError: examIsError,
    error: examError,
    isLoading: examIsLoading,
    data: exam
  } = useExam(examId ? parseInt(examId) : undefined);
  const {
    isError: examReportsIsError,
    error: examReportsError,
    isLoading: examReportsIsLoading,
    data: examReports
  } = useExamReportsRanking(examId ? parseInt(examId) : undefined);

  if (!examId) return <Error />;
  if (!student) return <Segment textAlign='center'>داوطلبی یافت نشد.</Segment>;
  if (examIsError) return <Error error={examError as APIErrorType} />;
  if (examReportsIsError) {
    const error = examReportsError as APIErrorType;
    return <Error error={error} />;
  }
  if (examIsLoading || examReportsIsLoading) return <Loader />;
  if (!exam) {
    return <Segment textAlign='center'>آزمونی یافت نشد.</Segment>;
  }
  if (!examReports || examReports.length === 0) {
    return <Segment textAlign='center'>هیچ رتبه‌بندی‌ای برای این آزمون یافت نشد.</Segment>;
  }

  return (
    <div>
      <ExamRankingTitle examName={exam.name} />
      <ExamRankingTable examReports={examReports} studentId={student.id} />
    </div>
  );
}

export default ExamRankingContainer;
